import { render } from "./ResaleBox.vue?vue&type=template&id=7ac42408&scoped=true&ts=true"
import script from "./ResaleBox.vue?vue&type=script&lang=ts"
export * from "./ResaleBox.vue?vue&type=script&lang=ts"

import "./ResaleBox.vue?vue&type=style&index=0&id=7ac42408&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ac42408"]])

export default __exports__